module.exports = __webpack_public_path__ + "static/score-8ab73377cc895dded2ab4203e61e5075.png";